import {
  AddOutlined,
  ControlCameraOutlined,
  Delete,
} from "@mui/icons-material";
import React from "react";
import { useTranslation } from "react-i18next";

export interface EditToolsType {
  id: string;
  icon: JSX.Element;
  title: string;
  description: string;
}

export const editTools = (): EditToolsType[] => {
  const { t } = useTranslation();
  return [
    {
      id: "add",
      icon: <AddOutlined />,
      title: t("edit.add_title"),
      description: t("edit.add_description"),
    },
    {
      id: "edit",
      icon: <ControlCameraOutlined />,
      title: t("edit.geometry_title"),
      description: t("edit.geometry_description"),
    },
    {
      id: "delete",
      icon: <Delete />,
      title: t("edit.delete_title"),
      description: t("edit.delete_description"),
    },
  ];
};
